"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDurationType = exports.camelToSnake = exports.snakeToCamel = void 0;
const constant_1 = require("../constant");
const long_1 = __importDefault(require("long"));
/**
 * converts snakecase strings to camelcase
 * @param snakeStr string to convert to camelcase
 */
const snakeToCamel = (snakeStr) => {
    if (!snakeStr.includes("_")) {
        return snakeStr;
    }
    const camelArr = snakeStr.split("_").map((snakeItem, index) => {
        if (index === 0) {
            return snakeItem;
        }
        return snakeItem.length > 1 ? `${snakeItem[0].toUpperCase()}${snakeItem.substr(1)}` : snakeItem.toUpperCase();
    });
    return camelArr.join("");
};
exports.snakeToCamel = snakeToCamel;
/**
 * converts snakecase strings to camelcase
 * @param camelStr string to convert to camelcase
 */
const camelToSnake = (camelStr) => {
    if (camelStr.length <= 1) {
        return camelStr;
    }
    let newSnake = "";
    for (const letter of camelStr) {
        const newLetter = letter !== letter.toLowerCase() ? `_${letter.toLowerCase()}` : letter;
        newSnake = `${newSnake}${newLetter}`;
    }
    return newSnake;
};
exports.camelToSnake = camelToSnake;
const isDurationType = (value) => {
    return long_1.default.isLong(value === null || value === void 0 ? void 0 : value.seconds) && typeof (value === null || value === void 0 ? void 0 : value.nanos) === "number";
};
exports.isDurationType = isDurationType;
